import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authReducer } from './store/reducers/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SharedPrimengModule } from './shared/shared-primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withFetch,
} from '@angular/common/http'; // Import HttpClientModule

import { CoreModule } from './core/core.module';
import { FeaturesModule } from './features/features.module';
import { SharedModule } from './shared/shared.module';
import { LoadingspinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { MessageService } from 'primeng/api';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogService } from 'primeng/dynamicdialog';

import {
  spinnerReducer,
  warningReducer,
} from './store/reducers/warning.reducer';
import { WarningEffects } from './store/effects/warning.effects';
import { appReducer } from './store/common/app.reducer';
import { AppEffects } from './store/common/app.effects';
import { HomeEffects } from './store/effects/home.effects';
import { homeReducer } from './store/reducers/home.reducer';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SpinnerInterceptor } from './auth/interceptor/spinner-interceptor';
import { AuthInterceptor } from './auth/interceptor/interceptor';
import { IconsModule } from './shared/icons.module';
import { providePrimeNG } from 'primeng/config';
import LaraLightBlue from '../lara-light-blue';
import { ToastModule } from 'primeng/toast';


@NgModule({
  declarations: [AppComponent, LoadingspinnerComponent],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule,
    ToastModule,
    AppRoutingModule,
    StoreModule.forRoot({
      auth: authReducer,
      spinner: spinnerReducer,
      warning: warningReducer,
      app: appReducer,
      home: homeReducer,

    }),
    EffectsModule.forRoot([
      WarningEffects,
      AppEffects,
      HomeEffects,

    ]),
    SharedModule,
    SharedPrimengModule,
    ReactiveFormsModule,
    CoreModule,
    FeaturesModule,
    HttpClientModule,
    IconsModule,
  ],
  providers: [
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    providePrimeNG({
      theme: {
        preset: LaraLightBlue,
        options: {
          prefix: 'p',
          darkModeSelector: '.my-app-dark',
          cssLayer: false,
        },
      },
      ripple: true,
    }),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    MessageService,
    DialogService,
    provideCharts(withDefaultRegisterables()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
